import { render, staticRenderFns } from "./ConceptSphere.vue?vue&type=template&id=1626e98b&scoped=true"
import script from "./ConceptSphere.vue?vue&type=script&lang=js"
export * from "./ConceptSphere.vue?vue&type=script&lang=js"
import style0 from "./ConceptSphere.vue?vue&type=style&index=0&id=1626e98b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626e98b",
  null
  
)

export default component.exports